module.exports = __webpack_public_path__ + "static/media/project3.dc01c737.jpg";